import { createContext, ReactNode, useContext } from 'react';
import { DEFAULT_FLOATING_Z_INDEX } from '../../../styles/zIndexes';

/**
 * A special context that handles a proper z-index for floating elements:
 * modals, popovers, tooltips, and dropdowns
 * It will increase default z-index based on "layer" where component renders
 *
 * Examples:
 * 1. We open a dropdown in Builder - z-index should be default
 * 2. We open dropdown that renders in modal - z-index should be default+1
 * 3. We open popover that is a part of dropdown, dropdown renders in modal -
 *    z-index should be default+3
 */

interface IFloatingLayerContextProviderProps {
  children: ReactNode;
}

const FloatingLayerContext = createContext(DEFAULT_FLOATING_Z_INDEX);

export const useFloatingLayerContext = () => useContext(FloatingLayerContext);

export const FloatingLayerProvider = ({
  children,
}: IFloatingLayerContextProviderProps) => {
  return (
    <FloatingLayerContext.Consumer>
      {(zIndex) => (
        <FloatingLayerContext.Provider value={zIndex + 1}>
          {children}
        </FloatingLayerContext.Provider>
      )}
    </FloatingLayerContext.Consumer>
  );
};
